import './index.css';

export default function Footer() {
  return (
    <div className='footer'>
      <div className='copyright center'>
        <p className='copyright-font textmode'>© Copyright 2021, MochiLab</p>
      </div>
    </div>
  );
}
